module.exports = {
    relevantClientId: 'A4689379-2C49-11EC-8813-1264B5C78F33',
    realAnswerClientId: 'A4689379-2C49-11EC-8813-1264B5C78F33'
};